<template>
    <b-nav class="w-100 flex-lg-column" id="tests_nav">
        <b-nav-item :to="{name: 'tests_active'}">{{ $t('tests.active_tests') }}</b-nav-item>
        <b-nav-item :to="{name: 'tests_completed'}">{{ $t('tests.completed_tests') }}</b-nav-item>
        <b-nav-item :to="{name: 'tests_drafts'}">{{ $t('tests.draft_tests') }}</b-nav-item>
    </b-nav>
</template>

<script>
    export default {
        name: 'tests-nav'
    }
</script>

<style scoped>

</style>
